import { render, staticRenderFns } from "./transportOrder.vue?vue&type=template&id=82c4f5e6&"
import script from "./transportOrder.vue?vue&type=script&lang=js&"
export * from "./transportOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports